module.exports = __webpack_public_path__ + "media/images/emblems/Huettwilen-0ea7c0444baeb4f0a4db196c98593151.gif";